export default __webpack_public_path__ + "static/media/480_store03-en-web.4e718d04.png";